// Lab registry: every simulator lab behind one uniform record so the UI,
// search, and scenario tooling stay generic.
import lab1Adapter, { labMeta as lab1Meta, defaultConfig as lab1Config, sampleCommands as lab1Commands } from './lab1/model';
import { ALL_SCENARIOS as lab1Scenarios } from './lab1/scenarios';
import lab2Adapter, { labMeta as lab2Meta, defaultConfig as lab2Config, sampleCommands as lab2Commands } from './lab2/model';
import { ALL_SCENARIOS as lab2Scenarios } from './lab2/scenarios';
import lab3Adapter, { labMeta as lab3Meta, defaultConfig as lab3Config, sampleCommands as lab3Commands } from './lab3/model';
import { ALL_SCENARIOS as lab3Scenarios } from './lab3/scenarios';
import lab4Adapter, { labMeta as lab4Meta, defaultConfig as lab4Config, sampleCommands as lab4Commands } from './lab4/model';
import { ALL_SCENARIOS as lab4Scenarios } from './lab4/scenarios';
import pingpongAdapter, { labMeta as pingpongMeta, defaultConfig as pingpongConfig, sampleCommands as pingpongCommands } from './pingpong/model';
import { ALL_SCENARIOS as pingpongScenarios } from './pingpong/scenarios';

export const LABS = [
  { id: 'lab1', meta: lab1Meta, adapter: lab1Adapter, defaultConfig: lab1Config, scenarios: lab1Scenarios, sampleCommands: lab1Commands },
  { id: 'lab2', meta: lab2Meta, adapter: lab2Adapter, defaultConfig: lab2Config, scenarios: lab2Scenarios, sampleCommands: lab2Commands },
  { id: 'lab3', meta: lab3Meta, adapter: lab3Adapter, defaultConfig: lab3Config, scenarios: lab3Scenarios, sampleCommands: lab3Commands },
  { id: 'lab4', meta: lab4Meta, adapter: lab4Adapter, defaultConfig: lab4Config, scenarios: lab4Scenarios, sampleCommands: lab4Commands },
  { id: 'pingpong', meta: pingpongMeta, adapter: pingpongAdapter, defaultConfig: pingpongConfig, scenarios: pingpongScenarios, sampleCommands: pingpongCommands, fixture: true },
];

export function getLab(id) {
  return LABS.find((l) => l.id === id) || LABS[0];
}

// The ping/pong lab is an engine fixture, not coursework: it stays available
// for direct links and tests but hides from the lab pickers unless ?fixture
// is present.
export function visibleLabs(search) {
  const query = search === undefined && typeof window !== 'undefined' ? window.location.search : search || '';
  if (query.includes('fixture')) return LABS;
  return LABS.filter((l) => !l.fixture);
}
